(function() {
  if (!/\/products\//.test(window.location.pathname)) return;
  if (!window.matchMedia('(max-width: 768px)').matches) return;

  function init() {
    var mainCta = document.querySelector('product-form buy-buttons button[type="submit"]');
    if (!mainCta) return;

    var titleEl = document.querySelector('h1.product-title');
    // Fix 2026-06-29 (Héphaïstos) — scope le prix au produit : sinon querySelector
    // attrapait le 1er <sale-price> du DOM (tiroir panier) -> prix erroné dans la barre.
    var infoScope = document.querySelector('.product-info') || document;
    var priceEl = infoScope.querySelector('price-list, .price-list, .price, sale-price, regular-price');
    var imgEl = document.querySelector('.product-gallery img, product-gallery img, .product-info img');
    if (!titleEl || !priceEl) return;

    var bar = document.createElement('div');
    bar.className = 'hl-product-sticky';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<div class="hl-product-sticky__img"></div>' +
                    '<div class="hl-product-sticky__info">' +
                      '<div class="hl-product-sticky__title"></div>' +
                      '<div class="hl-product-sticky__price"></div>' +
                    '</div>' +
                    '<button type="button" class="hl-product-sticky__btn">Ajouter</button>';

    if (imgEl) {
      var img = document.createElement('img');
      var src = imgEl.currentSrc || imgEl.src;
      // Force thumbnail Shopify CDN — display 77x77 mobile, marge DPI 2x = 180w max
      // Patch 2026-05-25 (Héphaïstos) — évite de copier l'URL pleine résolution (~200 KB)
      var thumb = src.replace(/([?&])width=\d+/, '$1width=180');
      if (thumb === src) {
        thumb += (src.indexOf('?') >= 0 ? '&' : '?') + 'width=180';
      }
      img.src = thumb;
      img.alt = '';
      img.loading = 'lazy';
      img.width = 60;
      img.height = 60;
      bar.querySelector('.hl-product-sticky__img').appendChild(img);
    }
    bar.querySelector('.hl-product-sticky__title').textContent = titleEl.textContent.trim();
    bar.querySelector('.hl-product-sticky__price').innerHTML = priceEl.innerHTML;

    document.body.appendChild(bar);

    var stickyBtn = bar.querySelector('.hl-product-sticky__btn');

    function getCurrentMainCta() {
      return document.querySelector('product-form buy-buttons button[type="submit"]') || mainCta;
    }

    function syncStickyButtonState() {
      var currentMainCta = getCurrentMainCta();
      var btnLabel = currentMainCta.textContent.trim();
      var isUnavailable = currentMainCta.disabled || currentMainCta.getAttribute('aria-disabled') === 'true';

      stickyBtn.disabled = isUnavailable;
      stickyBtn.setAttribute('aria-disabled', isUnavailable ? 'true' : 'false');

      if (isUnavailable) {
        stickyBtn.textContent = btnLabel && btnLabel.length <= 14 ? btnLabel : 'En rupture';
      } else {
        stickyBtn.textContent = btnLabel && btnLabel.length <= 12 ? btnLabel : 'Ajouter';
      }
    }

    syncStickyButtonState();

    stickyBtn.addEventListener('click', function() {
      var currentMainCta = getCurrentMainCta();
      if (stickyBtn.disabled || currentMainCta.disabled) return;
      currentMainCta.click();
    });

    // Fix 2026-07-01 (Hephaistos) -- la zone image/titre/prix n'avait aucun handler (clic mort
    // detecte via Clarity, session 30/06 : tap sur le titre, rien ne se passe, l'utilisateur repart).
    // Choix : remonte vers la fiche produit (pas d'ajout au panier surprise, la barre n'a pas de
    // selecteur de variante).
    function scrollToProductInfo() {
      (titleEl || mainCta).scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    bar.querySelector('.hl-product-sticky__img').addEventListener('click', scrollToProductInfo);
    bar.querySelector('.hl-product-sticky__info').addEventListener('click', scrollToProductInfo);

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          bar.classList.remove('is-visible');
          bar.setAttribute('aria-hidden', 'true');
        } else {
          bar.classList.add('is-visible');
          bar.setAttribute('aria-hidden', 'false');
        }
      });
    }, { threshold: 0.1 });
    observer.observe(mainCta);

    var productRerender = mainCta.closest('product-rerender') || infoScope;
    var stateObserver = new MutationObserver(function() {
      syncStickyButtonState();
    });
    stateObserver.observe(productRerender, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled']
    });

    var form = document.querySelector('product-form form');
    if (form) {
      form.addEventListener('change', function() {
        setTimeout(function() {
          var currentInfoScope = document.querySelector('.product-info') || infoScope;
          var p = currentInfoScope.querySelector('price-list, .price-list, .price, sale-price, regular-price');
          if (p) bar.querySelector('.hl-product-sticky__price').innerHTML = p.innerHTML;
          syncStickyButtonState();
        }, 150);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
